import script from "./KColourPicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./KColourPicker.vue?vue&type=script&setup=true&lang=ts"

import "./KColourPicker.vue?vue&type=style&index=0&id=e84f997a&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e84f997a"]])

export default __exports__
import QColor from 'quasar/src/components/color/QColor.js';
import QSlider from 'quasar/src/components/slider/QSlider.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QColor,QSlider});
